import DOMPurify from 'dompurify';
import React from 'react';

/**
 * Class to define the search result tiles which maintain a different styling
 * from the center tile.
 */
export default class SearchResultTile extends React.Component {
    render() {
        if (!this.props.pageUrl) {
            return;
        }
        const imageBlock = []; //Here mostly for future posterity. Currently not expecting any images from search assist responses.
        if (this.props.pageImageUrl) {
            imageBlock.push(
                <div className='result-tile__image'>
                    <img src={DOMPurify.sanitize(this.props.pageImageUrl)} alt='To be determined how to implement...'></img>
                </div>
            );
        }
        let pageTitleBlock;
        if (this.props.pageTitle.trim() !== '') {
            pageTitleBlock = <div className='result-tile__page-title'>
                {this.props.pageTitle}
            </div>
        }
        let pagePreviewBlock;
        if (this.props.pagePreview.trim() !== '') {
            pagePreviewBlock = <div className='result-tile__page-preview'>
                {this.props.pagePreview}
            </div>
        }
        return(
            /**
             * Note the ref for this item is passed through from the parent if needed.
             * If this is any other result tile other than the first, the ref value
             * in props will be undefined.
             */
            <a className='search__result-tile result-tile'
                href={this.props.pageUrl}
                title={`Learn more about ${this.props.pageTitleBlock}. (Loads a new page.)`}
                ref={this.props.focusRef}>
                <div className='result-tile__wrapper'>
                    {pageTitleBlock}
                    {pagePreviewBlock}
                </div>
                <div className='result-tile__arrow'></div>
            </a>
        );
    }
}